@if (loaded) {
<div>
  <tutor-report-learner-journey-flow #report lessonPlanType="LeapV2"></tutor-report-learner-journey-flow>
</div>
}
